import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Button, Col, Input, FormGroup, Label, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Step6TableColumns from './Step6TableColumns';
import Pagination from '../diy-utils/Pagination';
import { handleRowCheckboxWithSet } from '../diy-utils/checkboxHandlers';
import { handleSelectAllByIdStep6 } from './utils';
import { linkToStep } from '../utilities/linkToStep';

const sizeOptions = [50, 100, 200];
class Step6Table extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itemsPerPage: sizeOptions[0],
      showDeletedItems: false,
      showPublish: false,
      disablePublish: false,
    };
  }

  componentDidMount() {
    this.handleDisablePublish();
  }

  componentDidUpdate(_, prevState) {
    if (prevState.showPublish !== this.state.showPublish) {
      this.handleDisablePublish();
    }
  }

  handlePageSize = e => {
    const { handlePageClick } = this.props;
    this.setState({ itemsPerPage: +e.target.value });
    handlePageClick({ selected: 0 });
  };

  /**
   * Toggle selected/unselected items on the table
   * if any item selected is un-lotted - do not display  (this could be all unlotted items selected or a mix of both)
   * if all selected item(s) are lotted but already published - do not display
   * if all selected item(s) are lotted and none or some are unpublished - display publish selected button
   * @param {*} row
   */
  handleCheckbox = row => {
    const { areUnpublishedLots, handleSelectedLots, lots, selectedLots } = this.props;
    const newSelectedLotsId = handleRowCheckboxWithSet(row, selectedLots);
    const areSelectedLots = newSelectedLotsId.size > 0;
    const arePublishedSelected = lots.some(lot => {
      if (newSelectedLotsId.has(lot.lotID) && !lot.unpublished && !lot.deleted) {
        return true;
      }
      return false;
    });

    const isUnlotted = lots.some(lot => newSelectedLotsId.has(lot.lotID) && !lot.lotNumber);

    handleSelectedLots(newSelectedLotsId);

    this.setState({
      showPublish: areUnpublishedLots && areSelectedLots && !isUnlotted && !arePublishedSelected,
    });
  };

  handleDeletedItemsCheckbox = () => {
    this.setState({ showDeletedItems: !this.state.showDeletedItems });
  };

  // Select all or unselect all items currently on the page
  handleCheckboxAll = () => {
    const { itemsPerPage } = this.state;
    const { currentPage, handleSelectedLots, lots, selectedLots } = this.props;

    const newSelectedLots = handleSelectAllByIdStep6(currentPage, itemsPerPage, lots, selectedLots);
    const arePublishedSelected = lots.some(lot => newSelectedLots.has(lot.lotNumber) && lot.unpublished && !lot.deleted);

    handleSelectedLots(newSelectedLots);
    this.setState({
      showPublish: arePublishedSelected,
    });
  };

  // Return true if lots does not contain lot.lotNumber
  validateLotNumber = (lots) => {
    const lotFound = lots.find(lot => !lot.lotNumber);
    return !lotFound;
  }

  validateLotsSelected = (selectedLots) => {
    const { connectType, lots } = this.props;
    const ycConnectTypes = ['e', 'p'];
    const isPlatinumGold = ycConnectTypes.indexOf(connectType) > -1;
    const newSelectedLots = Array.from(selectedLots);

    const selected = newSelectedLots.map((sl) => Number(sl));

    const lotsFilteredSelected = lots.filter(lot => selected.includes(lot.id));
    const lotFound = lotsFilteredSelected
      .find(lot => (isPlatinumGold ? !lot.lotNumber : !lot.lotNumber));

    return !lotFound;
  }

  handleDisablePublish = () => {
    const { lots } = this.props;
    const isValid = this.validateLotNumber(lots);
    if (isValid) {
      this.setState({ disablePublish: false });
    } else {
      this.setState({ disablePublish: true });
    }
  }

  render() {
    const {
      currentPage,
      dropdownCheck,
      handlePageClick,
      handleDropdownMessage,
      isBanned,
      isPotentiallyBanned,
      isTimed,
      isRestricted,
      isUnpublished,
      lots,
      noImage,
      numImages,
      numImagesInvNumber,
      numLots,
      isShippingEnabled,
      selectedLots,
      showPublishButton,
      submitStepSix,
      toggleDeleteBulkModal,
      toggleDeleteLotModal,
      togglePublishAllModal,
      togglePublishBulkModal,
      twoHrsPassed,
    } = this.props;

    const {
      itemsPerPage,
      showDeletedItems,
      showPublish,
      disablePublish,
    } = this.state;

    const {
      match: {
        params: { catalogID, groupID, type }
      },
    } = this.props;

    const isBin = type.toLowerCase() === 'bin';
    const linkedFrom = isBin ? 'step5' : 'step6';

    let parsedLots = lots;
    let parsedNumLots = numLots;

    // (dyouberg) For BIN - We only show deleted items if the user clicks the checkbox
    const liveLots = lots.filter(lot => !lot.deleted);
    if (isBin && !showDeletedItems) {
      parsedLots = liveLots;
      parsedNumLots = parsedLots.length;
    } else if (!isBin) {
      // (dyouberg) For live/timed - only count non deleted items in the total # of items
      parsedNumLots = liveLots.length;
    }

    /**
     * INVA-2351: Different permutations and different behaviors leads to hard to track down issues.
     *
     * Make sure that we account for all items (including deleted) if we are not in the buy now
     * permutation - which only cares about deleted items when a filter is enabled.
     */
    const numPages = Math.ceil((isBin ? parsedNumLots : lots.length) / itemsPerPage);

    const renderLotsPerPage = (
      <FormGroup row className="mb-0 mr-0">
        <Label xs={6} className="font-weight-bold text-right text-nowrap pr-0" for="lotsPerPage">Per Page</Label>
        <Col xs={6} className="pr-0">
          <Input type="select" name="select" id="lotsPerPage" onChange={e => this.handlePageSize(e)}>
            {sizeOptions.map(sizeOption => (
              <option key={sizeOption}>{sizeOption}</option>
            ))}
          </Input>
        </Col>
      </FormGroup>
    );

    return (
      <Fragment>
        <Row className="mt-4">
          <Col>
            <p className="font-weight-bold mb-0">Item(s) Summary</p>
            <p className="mb-0">Total # of Items: {parsedNumLots}, Total # of Images: {numImages + numImagesInvNumber}</p>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col xs={4}>
            <Link to={isBin ? linkToStep(4) : linkToStep(5)} className="btn-link">
              <FontAwesomeIcon icon="eye" />&nbsp;Preview session
            </Link>
          </Col>
          {!twoHrsPassed
            && (
            <Col>
              <Link
                className="float-right"
                to={{
                  pathname: `/session/${type}/${groupID}/${catalogID}/lot/0`,
                  state: { linkedFrom }
                }}
                aria-label="Add"
              >
                <FontAwesomeIcon icon="plus" />&nbsp;Add single item
              </Link>
            </Col>
            )}
          {!twoHrsPassed
            && (
            <Col>
              <Link
                to={{
                  pathname: isBin ? linkToStep(2) : linkToStep(3),
                  state: { linkedFrom }
                }}
                aria-label="Bulk upload/edit items"
                className="float-right"
              >
                <FontAwesomeIcon icon="edit" />&nbsp;Bulk upload/edit items
              </Link>
            </Col>
            )}
          <Col>
            <Link
              to={{
                pathname: isBin ? linkToStep(3) : linkToStep(4),
                state: { linkedFrom }
              }}
              className="btn-link float-right"
            >
              <FontAwesomeIcon icon="images" />&nbsp;Bulk upload images
            </Link>
          </Col>
        </Row>
        <Row className="my-3 align-items-center">
          {showPublishButton && (
            <Col xs={2}>
              <Button
                className="w-100"
                color="primary"
                onClick={() => togglePublishAllModal()}
                disabled={disablePublish}
              >
                Publish All
              </Button>
            </Col>
          )}
          {isShippingEnabled && (
            <Col xs={2} className="d-flex align-items-center">
              <Button
                className="w-100"
                color="diy-secondary"
                onClick={() => submitStepSix('continue')}
              >
                Continue to Shipping
              </Button>
            </Col>
          )}
          <Col className="d-flex justify-content-end">{renderLotsPerPage}</Col>
        </Row>
        <Row className="my-3">
          <Col xs={2} className="d-flex align-items-center justify-content-center">
            {!twoHrsPassed && selectedLots.size > 0 && (
              <button
                className="btn-link border-0 bg-transparent"
                onClick={() => toggleDeleteBulkModal(selectedLots)}
                type="button"
              >
                <FontAwesomeIcon icon="trash-alt" />
                &nbsp;Delete selected
              </button>
            )}
          </Col>
          <Col xs={3} className="d-flex align-items-center">
            {showPublish && (this.validateLotsSelected(selectedLots) > 0) && (
              <button
                className="btn-link border-0 bg-transparent"
                onClick={() => togglePublishBulkModal(selectedLots)}
                type="button"
              >
                <FontAwesomeIcon icon="upload" />
                &nbsp;Publish selected
              </button>
            )}
          </Col>
          {isBin
            && (
            <Col xs={3} className="d-flex align-items-center">
              <Input
                className="ml-0 position-relative text-nowrap"
                checked={showDeletedItems}
                onChange={() => this.handleDeletedItemsCheckbox()}
                type="checkbox"
              />
              &nbsp;Show deleted items
            </Col>
            )}
        </Row>
        <ReactTable
          minRows={1}
          className="-highlight step6-table"
          data={parsedLots}
          columns={Step6TableColumns({
            dropdownCheck,
            handleCheckbox: this.handleCheckbox,
            handleCheckboxAll: this.handleCheckboxAll,
            handleDropdownMessage,
            isBanned,
            isPotentiallyBanned,
            isRestricted,
            isUnpublished,
            isTimed,
            noImage,
            routeParams: { catalogID, groupID, type },
            selectedLots,
            toggleDeleteLotModal,
            twoHrsPassed,
            currentPage,
          })}
          showPagination={false}
          page={currentPage}
          pageSize={itemsPerPage}
          getTrProps={(state, rowInfo) => ({
            className: rowInfo && rowInfo.original.deleted ? 'row-deleted font-italic' : '',
          })}
        />
        <Pagination
          classNames="mt-3"
          handlePageClick={handlePageClick}
          numPages={numPages}
          currentPage={Number(currentPage)}
        />
      </Fragment>
    );
  }
}

export default withRouter(Step6Table);
